<div *ngIf="showLoading" class="reward-detail-loading" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
    <div class="loading-spinner">
        <div class="large progress" alt="Loading..." aria-label="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!showLoading" class="mt-2 px-2">
    <ng-container *ngIf="!isErrorInContent">
                <div class="pds-accordion">
                    <h2 class="py-3 mb-0">
                        <button class="pds-accordion__header d-flex align-items-center justify-content-between pl-0 w-100 border-0 bg-transparent"
                                data-toggle="collapse" data-target="#partnerFaq" aria-expanded="false"
                                aria-controls="partnerFaq" id="faqHeading"><span class="poppins-title-lg"
                                                                                 style="text-align: left; color: #2a2928;">Frequently asked questions</span><span
                                class="svg-caret-collapse-md"></span><span class="svg-caret-expand-md"></span></button>
                    </h2>
                </div>
                <div id="partnerFaq" class="collapse" role="region" aria-labelledby="faqHeading">
                    <!-- paste FAQ's here -->
                    <div [innerHTML]="frequentlyAskedQuestion | safeHtml"></div>
                </div>
    </ng-container>
    <ng-container *ngIf="isErrorInContent">
    </ng-container>
</div>
